import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import TradingTerminal from './components/TradingTerminal';
import SmallScreenNotice from './components/SmallScreenNotice';
import NotFoundPage from './pages/NotFoundPage';
import './styles/App.css';

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/terminal" element={
            <PrivateRoute>
              <div className="app">
                <SmallScreenNotice />
                <TradingTerminal />
              </div>
            </PrivateRoute>
          } />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
      // toast position
        position="top-right"
        // CHANGE TOAST TIME (in milliseconds)
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="dark"
        toastStyle={{
          background: '#1B1C22',
          color: '#F5F5F5',
          border: '1px solid #363843',
          borderRadius: '6px',
          fontFamily: "'Onest', sans-serif",
          fontSize: '13px',
        }}
      />
    </AuthProvider>
  );
};

export default App;
